/**
 * Determines if "Requested Working Man Hours" fields should be hidden
 * @param eventTypeName - Event type name from the system
 * @returns true if fields should be hidden (Production Support only)
 */
export const shouldHideWorkingManHours = (eventTypeName?: string): boolean => {
  if (!eventTypeName) return false;
  return eventTypeName.toLowerCase().includes('production support');
};

/**
 * Determines if "w/d" (working days) indicator should be hidden
 * @param eventTypeName - Event type name from the system
 * @returns true if indicator should be hidden (Production Support only)
 */
export const shouldHideWorkingDaysIndicator = (eventTypeName?: string): boolean => {
  if (!eventTypeName) return false;
  return eventTypeName.toLowerCase().includes('production support');
};
